import { OrganizationSupplementalSystem } from '@models/organizationSupplementalSystem.model';
import { createActionGroup, emptyProps, props } from '@ngrx/store';

export const OrgSupplementalSystemActions = createActionGroup({
  source: 'OrgSupplementalSystem',
  events: {
    'Open Add Pressed': emptyProps(),
    'Open Add System Type Selected': props<{ systemType: 'EHR' | 'PM/Billing' }>(),
    'Open Edit Pressed': props<{ system: OrganizationSupplementalSystem }>(),
    'Open Delete Pressed': props<{ id: number; name: string; systemType: string }>(),

    'Add Org Supplemental System': props<{ data: any }>(),
    'Add Org Supplemental System Success': props<{ data: OrganizationSupplementalSystem }>(),
    'Add Org Supplemental System Failure': props<{ error: string }>(),
    'Add Org Supplemental System Conflict': props<{ message: string }>(),

    'Update Org Supplemental System': props<{ form: any; orgId: number; systemId: number; systemType: string; legacyEhrpmDeliveryMethod?: string | null }>(),
    'Update Org Supplemental System Success': props<{ system: OrganizationSupplementalSystem }>(),
    'Update Org Supplemental System Failure': props<{ error: string }>(),
    'Update Org Supplemental System Conflict': props<{ message: string }>(),

    'Delete Org Supplemental System': props<{ id: number; systemType: string }>(),
    'Delete Org Supplemental System Success': props<{ id: number }>(),
    'Delete Org Supplemental System Failure': props<{ error: string }>(),
  }
});
